export default {
  roles: {
    PreChecker: 'Υπάλληλος Προελέγχου',
    SpecialProponent: 'Χειριστής',
    ExecutiveBoardMember: 'Μέλος Επιτροπής',
    President: 'Πρόεδρος',
    VicePresidentA: 'Αντιπρόεδρος Α',
    VicePresidentB: 'Αντιπρόεδρος Β',
    ProcessViewer: 'Διοικητικός Έλεγχος',
    Admin: 'Διαχειριστής',
    RegistryAdmin: 'Διαχειριστής Μητρώων',
    PhdRegistry: 'Σύνδεσμος ΕΑΔΔ',
    CouncilMember: 'Μέλος ΔΣ',
    DocutracksUser: 'Χρήστης ΣΗΔΕ (Docutracks)',
    TemporaryUser: 'Προσωρινός χρήστης',
    PrintDecision: 'Καταχωρητής Απόφασης',
    AcademicConsultant: 'Αξιολογητής'
  },
  bachelor: 'Βασικό Πτυχίο',
  master: 'Μεταπτυχιακό',
  phd: 'Διδακτορικό',
  appTypes: [
    { id: 1100, name: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 1ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ' },
    { id: 1200, name: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 2ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ' },
    { id: 1300, name: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 3ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ' },
    { id: 2100, name: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 1ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ ΜΕ ΣΥΝΥΠΟΒΟΛΗ ΤΙΤΛΟΥ 2ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ' },
    { id: 3100, name: 'ΕΠΑΝΕΞΕΤΑΣΗΣ ΑΙΤΗΜΑΤΟΣ ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ ΣΠΟΥΔΩΝ' },
    { id: 7100, name: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 1ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ ΜΕΤΑ ΑΠΟ ΑΝΤΙΣΤΑΘΜΙΣΤΙΚΑ ΜΕΤΡΑ' }
  ],
  appDistanceLearning: [
    { val: false, desc: 'Συμβατικός' },
    { val: true, desc: 'Εξ αποστάσεως' }
  ],
  reappSubmissionStatuses: [
    { val: false, desc: 'Εμπρόθεσμη' },
    { val: true, desc: 'Εκπρόθεσμη' }
  ],
  compensatoryMeasuresTypes: [
    { val: true, desc: 'Απόφαση Προέδρου με αντισταθμιστικά μέτρα' },
    { val: false, desc: 'Απόφαση Προέδρου χωρίς αντισταθμιστικά μέτρα' }
  ],
  appStates: [
    { id: 1, name: 'userW_', gr_name: 'Εξωτερικός Χρήστης' },
    { id: 2, name: 'precheckerW_', gr_name: 'Προέλεγχος' },
    { id: 3, name: 'proponentW_President', gr_name: 'Χειριστής από Πρόεδρο' },
    { id: 4, name: 'proponentW_Board', gr_name: 'Χειριστής από Εκτελεστική επιτροπή' },
    { id: 5, name: 'proponentW_Admin', gr_name: 'Χειριστής από Αναδρομολόγηση' },
    { id: 6, name: 'proponentW_Prechecker', gr_name: 'Χειριστής από Προέλεγχο' },
    { id: 7, name: 'viewerW_Proponent', gr_name: 'Έλεγχος από Χειριστή' },
    { id: 8, name: 'viewerW_Vice', gr_name: 'Έλεγχος από Αντιπρόεδρο' },
    { id: 9, name: 'viewerW_Board', gr_name: 'Έλεγχος από Εκτελεστική επιτροπή' },
    { id: 10, name: 'viewerW_President', gr_name: 'Διευθυντής Αναγνώρισης' },
    { id: 11, name: 'viceW_President', gr_name: 'Αντιπρόεδρος από Πρόεδρο' },
    { id: 12, name: 'boardW_President', gr_name: 'Εκτελεστική επιτροπή από Πρόεδρο' },
    { id: 13, name: 'boardW_Proponent', gr_name: 'Εκτελεστική επιτροπή από Εισηγητή' },
    { id: 14, name: 'boardW_Consultant', gr_name: 'Εκτελεστική επιτροπή από Ακαδημαϊκό' },
    { id: 15, name: 'presidentW_Prechecker', gr_name: 'Πρόεδρος από Προέλεγχο' },
    { id: 16, name: 'presidentW_PrintDecision', gr_name: 'Πρόεδρος από Καταχωρητή' },
    { id: 17, name: 'presidentW_Consultant', gr_name: 'Πρόεδρος από Αξιολογητή' },
    { id: 18, name: 'presidentW_Viewer', gr_name: 'Πρόεδρος' },
    { id: 19, name: 'presidentW_AcademicDirector', gr_name: 'Πρόεδρος' },
    { id: 20, name: 'printDecisionW_', gr_name: 'Καταχωρητής Απόφασης' },
    { id: 21, name: 'precheckersQueue', gr_name: 'Ουρά προελέγχου' },
    { id: 22, name: 'president_finalized', gr_name: 'Ολοκληρωμένη-Παραλαβή' },
    { id: 23, name: 'consultantW_Proponent', gr_name: 'Αξιολογητής από Χειριστή' },
    { id: 24, name: 'consultantW_President', gr_name: 'Αξιολογητής από Πρόεδρο' },
    { id: 25, name: 'boardW_', gr_name: 'Εκτελεστική επιτροπή' },
    { id: 26, name: 'REDIRECTION_NEEDED', gr_name: 'Επαναδρομολόγηση' },
    { id: 27, name: 'printDecisionW_President', gr_name: 'Ουρά καταχωρητών' },
    { id: 28, name: 'deactivated', gr_name: 'Απενεργοποιημένη' },
    { id: 29, name: 'reappraisalBoardW_President', gr_name: 'Ειδ. Επιτρ. Επανεξέτασης' },
    { id: 30, name: 'proponentW_ReappraisalBoard', gr_name: 'Χειριστής από Ειδ. Επιτρ. Επανεξέτασης' },
    { id: 31, name: 'academicDirectorW_Proponent', gr_name: 'Δ/ντής Ακαδ. Αναγνώρισης από Χειριστή (Επανεξ.)' },
    { id: 32, name: 'academicDirectorW_ReappraisalBoard', gr_name: 'Δ/ντής Ακαδ. Αναγνώρισης από Ειδ. Επιτρ. Επανεξ.' },
    { id: 33, name: 'presidentW_AcademicDirector_Reappraisal', gr_name: 'Πρόεδρος από Δ/ντή Ακαδ. Αναγνώρισης (Επανεξ.)' },
    { id: 34, name: 'presidentW_ReappraisalBoard', gr_name: 'Πρόεδρος από Ειδ. Επιτρ. Επανεξέτασης (επιστροφή)' },
    { id: 35, name: 'precheckerCompensatoryW_', gr_name: 'Προέλεγος μετά από Εξετάσεις σε Πανεπιστημιακό Ίδρυμα' }
  ]
}



// WEBPACK FOOTER //
// ./src/store/terms.js